import { Box, Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import CountrySelect from "../../../components/common/CountrySelect";
import Select from "../../../components/common/Select";

const RegulatoryBodyForm = ({
  regulatoryBody,
  onSubmit,
  onCancel,
  dropDownOptions,
}) => {
  const [formData, setFormData] = useState({
    id: regulatoryBody?.id || null,
    country: regulatoryBody?.country || "",
    abbreviation: regulatoryBody?.abbreviation || "",
    authority_name: regulatoryBody?.authority_name || "",
    region: regulatoryBody?.region || "",
  });

  const { regulatoryBodyRegionChoices } = dropDownOptions;

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {};

    if (!formData.country) {
      newErrors.country = "Country is required";
      valid = false;
    }
    if (!formData.authority_name) {
      newErrors.authority_name = "Authority name is required";
      valid = false;
    }
    if (!formData.region) {
      newErrors.region = "Region is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 my-3 sentry-mask">
      <Box>
        <Grid container spacing={2}>
          {/* Country */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <CountrySelect
              value={formData.country}
              id="country"
              onChange={(value) => handleChange("country", value)}
              error={!!errors.country}
              helperText={errors.country}
              required
            />
          </Grid>

          {/* Abbreviation */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id="abbreviation"
              value={formData.abbreviation}
              onChange={(e) => handleChange("abbreviation", e.target.value)}
              fullWidth
              placeholder="e.g. KCAA"
              label="Abbreviation"
            />
          </Grid>

          {/* Authority Name */}
          <Grid size={{ xs: 12 }}>
            <TextField
              id="authority_name"
              value={formData.authority_name}
              onChange={(e) => handleChange("authority_name", e.target.value)}
              fullWidth
              placeholder="e.g. Kenya Civil Aviation Authority"
              error={!!errors.authority_name}
              helperText={errors.authority_name}
              label="Authority Name"
            />
          </Grid>

          {/* Region */}
          <Grid size={{ xs: 12 }}>
            <Select
              error={!!errors.region}
              helperText={errors.region}
              label="Region"
              onChange={(value) => handleChange("region", value)}
              options={regulatoryBodyRegionChoices}
              value={formData.region}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Actions */}
      <div className="flex justify-end space-x-2 mt-4">
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </div>
    </form>
  );
};

export default RegulatoryBodyForm;
